import { TOGGLE_SIDEBAR_MODAL } from "./actionTypes";

export const toggleSideBarModal = () => ({
    type: TOGGLE_SIDEBAR_MODAL
});